import * as _ from "lodash";
import * as angular from "angular";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Filter } from "../../models/filter.model";
import { DialogUtils } from "../../helper/dialog.helper";

let ViewGroupFiltersDialogComponent = {
    selector: "vcViewGroupFiltersDialog",
    templateUrl:
        "/angular/components/group/view-group-filters-dialog.component.html",
    bindings: {
        group: "=",
    },
    controller: class ViewGroupFiltersDialogController {
        // * bindings for typescript compiler *
        public group: any;
        // ************************************

        public filter: Filter;

        private dialog: DialogUtils;
        public filterDataProvider: FilterDataProvider;

        constructor(
            FilterDataProvider: FilterDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.dialog = DialogUtils;

            this.filterDataProvider = FilterDataProvider;

            this.filter = new Filter();
        }

        $onInit() {
            let filters = this.group.filters;
            this.filter.setData(
                _.merge(this.filter, this.previousFilter(filters))
            );

            angular.forEach(filters, (value: object, key: number) => {
                this.filter[key].checked = true;
            });
            if (filters.custom_fields) {
                _.forEach(this.filter.custom_fields, (customField: any) => {
                    customField.checked = true;
                });
            }
        }

        previousFilter(filters: object[]): object {
            let new_filters = {};
            for (let key in filters) {
                if (
                    key != "custom_fields" &&
                    key != "elections" &&
                    key != "surveys"
                ) {
                    new_filters[key] = { values: filters[key] };
                } else {
                    new_filters[key] = filters[key];
                }
                new_filters[key].checked = true;
            }
            return new_filters;
        }

        closeDialog(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("group")
    .component(
        ViewGroupFiltersDialogComponent.selector,
        ViewGroupFiltersDialogComponent
    );
